/** Fashion Curated Finds — clothing, bags, watches, beauty, etc. */
import { SIDE_MENU_CATEGORIES } from './sideMenuCategories';

export const FASHION_CURATED_CATEGORY_VALUES = [
  'Clothing',
  'Footwear',
  'Bags',
  'Watches',
  'Accessories',
  'Beauty',
  'Beauty & Personal Care',
  'Beauty and Personal Care',
  'Luggage',
];

const FASHION_CURATED_CATEGORY_SET = new Set(FASHION_CURATED_CATEGORY_VALUES);

/** Values sent to the browse API when showing all Fashion Curated Finds. */
export function getFashionCuratedBrowseApiCategories() {
  return FASHION_CURATED_CATEGORY_VALUES.join(',');
}

export function isFashionCuratedCategory(category) {
  return typeof category === 'string' && FASHION_CURATED_CATEGORY_SET.has(category.trim());
}

/** Side-menu slice for Fashion Curated Finds browse. */
export const FASHION_CURATED_SIDE_MENU_CATEGORIES = {
  Clothing: SIDE_MENU_CATEGORIES.Clothing,
  Footwear: SIDE_MENU_CATEGORIES.Footwear,
  Bags: SIDE_MENU_CATEGORIES.Bags,
  Watches: SIDE_MENU_CATEGORIES.Watches,
  Accessories: SIDE_MENU_CATEGORIES.Accessories,
  'Beauty and Personal Care': {
    categoryValue: 'Beauty',
    subcategories: SIDE_MENU_CATEGORIES['Beauty and Personal Care']?.subcategories || [],
  },
  Luggage: {
    categoryValue: 'Luggage',
    subcategories: SIDE_MENU_CATEGORIES.Luggage?.subcategories || [],
  },
};
